import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket.tsx";
import { Button } from "@/components/core/buttons/button";
import { DynamicTagsInput } from "@/components/core/forms/dynamic-tags-input";
import { useModal } from "@/components/core/modals/use-modal.ts";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import SampleModal from "@/components/sample-modal";
import { IconMoodLookDown, IconPlus } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/_dashboard/")({
	component: DashboardIndex,
});

function DashboardIndex() {
	const modal = useModal();
	const [tags, setTags] = useState<string[]>(["Jimbeam", "Gin Bilog", "Absolut", "Red Horse", "Pale Malamig"]);

	return (
		<Content>
			<Header />
			<div className="flex flex-col w-full p-4">
				{/*<DynamicTagsInput value={tags} onChange={setTags} />*/}
				<Blanket width="sm">
					<BlanketImage icon={<IconMoodLookDown size={30} stroke={1.5} />} />
					<BlanketInfo
						title="No Data"
						message="No available data for for now. Please check back later or refresh the page."
						action={
							<Button
								onClick={() => {
									modal.openModal({
										title: "Default Modal",
										size: "md",
										component: <SampleModal />,
									});
								}}
							>
								<IconPlus size={18} stroke={2} />
								<span className="font-semibold pr-1">Create</span>
							</Button>
						}
					/>
				</Blanket>
			</div>
		</Content>
	);
}
